<template>
  <div
    v-if="visible"
    class="mod_double_login_mask"
    @touchmove.prevent.stop
  >
    <div class="mod_double_login">
      <i
        class="login__icon login__icon_cancel"
        data-role="button"
        @click="hide"
      >
        <svg
          class="login__svg_icon login__svg_icon_cancel"
          viewBox="0 0 32 32"
        >
          <!-- eslint-disable max-len -->
          <path d="M17.807 16.326l4.72 4.721c0.232 0.24 0.375 0.567 0.375 0.928 0 0.739-0.599 1.337-1.337 1.337-0.362 0-0.69-0.144-0.931-0.377l0 0-4.713-4.721-4.72 4.721c-0.24 0.233-0.569 0.377-0.931 0.377-0.739 0-1.337-0.599-1.337-1.337 0-0.361 0.143-0.688 0.375-0.929l-0 0 4.72-4.721-4.72-4.721c-0.232-0.24-0.375-0.568-0.375-0.928 0-0.739 0.599-1.337 1.337-1.337 0.362 0 0.69 0.144 0.931 0.377l4.72 4.721 4.713-4.721c0.24-0.233 0.569-0.377 0.931-0.377 0.739 0 1.337 0.599 1.337 1.337 0 0.361-0.143 0.688-0.375 0.929l0-0z" />
        </svg>
      </i>
      <div class="login_hd">
        <h1 class="login_title login_lh15">
          {{ isLogin ? '切换腾讯视频帐号' : '登录腾讯视频' }}
        </h1>
        <div v-if="canLogin && desc" class="login_subtitle login_lh15">
          {{ desc }}
        </div>
      </div>
      <div class="login_bd">
        <div class="login_list">
          <div v-if="canLogin" class="list_inner">
            <div class="list_item inner" @click="actionLogin('wx')">
              <i
                class="login__icon login__icon_wx_lg"
                :class="!canLoginWechat ? 'login__icon_gray' : ''"
              >
                <svg
                  class="login__svg_icon login__svg_icon_wx_lg"
                  viewBox="0 0 61.687 48.84"
                >
                  <!-- eslint-disable max-len -->
                  <path
                    fill-rule="evenodd"
                    d="M802.443,1072.29a20.971,20.971,0,0,1,2.1.12c-1.891-8.55-11.292-14.9-22.026-14.9-12,0-21.828,7.95-21.828,18.05,0,5.82,3.268,10.61,8.733,14.32l-2.182,6.38,7.631-3.72a38,38,0,0,0,7.646,1.07q1.026,0,2.038-.09a15.389,15.389,0,0,1-.675-4.44C783.883,1079.81,792.072,1072.29,802.443,1072.29Zm-11.735-5.75a2.651,2.651,0,1,1,0,5.3c-1.64,0-3.281-1.07-3.281-2.66S789.068,1066.54,790.708,1066.54Zm-15.278,5.3c-1.638,0-3.288-1.07-3.288-2.66s1.65-2.64,3.288-2.64A2.651,2.651,0,1,1,775.43,1071.84Zm46.936,16.98c0-8.48-8.733-15.39-18.541-15.39-10.386,0-18.568,6.91-18.568,15.39,0,8.5,8.182,15.4,18.568,15.4a28.2,28.2,0,0,0,6.548-1.06l5.988,3.18-1.64-5.3C819.1,1097.84,822.366,1093.61,822.366,1088.82Zm-24.561-2.65a2.126,2.126,0,1,1,0-4.25,2.48,2.48,0,0,1,2.733,2.13C800.538,1085.12,799.454,1086.17,797.805,1086.17Zm12,0a2.125,2.125,0,1,1,0-4.25,2.485,2.485,0,0,1,2.732,2.13C812.542,1085.12,811.449,1086.17,809.81,1086.17Z"
                    transform="translate(-760.688 -1057.5)"
                  />
                </svg>
              </i>
              <div class="info">
                <div class="box">
                  <h6 v-if="canLoginWechat" class="title login_lh15">
                    {{ isLogin ? '切换微信登录' : '登录微信' }}
                  </h6>
                  <h6 v-else class="title login_lh15 login__txt_sub">
                    {{ env === 'wechat' ? (isLogin ? '切换微信登录' : '登录微信') : '无法使用微信登录' }}
                  </h6>
                </div>
              </div>
            </div>
            <div class="list_item inner" @click="actionLogin('qq')">
              <i
                class="login__icon login__icon_qq_lg"
                :class="!canLoginQQ ? 'login__icon_gray' : ''"
              >
                <img
                  src="https://puui.qpic.cn/vupload/0/1585021957105_ojhitufcza.png/0"
                  class="login__svg_icon login__svg_icon_qq_lg"
                >
              </i>
              <div class="info">
                <div class="box">
                  <h6 v-if="canLoginQQ" class="title login_lh15">
                    {{ isLogin ? '切换QQ登录' : '登录QQ' }}
                  </h6>
                  <h6 v-else class="title login_lh15 login__txt_sub">
                    {{ env === 'mqq' ? '切换QQ登录' : '无法切换QQ帐号' }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="login_desc">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="login_lh15" @click="descTextClick" v-html="descText" />
            <template v-if="!canLogin">
              <a v-if="canOpenApp" class="disable_btn" @click="launchApp">打开腾讯视频</a>
              <a v-else class="disable_btn" @click="clipboard">复制链接</a>
            </template>
          </div>
          <div v-if="canLogin" class="login_agreement login_lh15">
            <input id="agreement" v-model="isAgreementChecked" type="checkbox">
            <label for="agreement" />
            <div class="text login_lh15">
              同意<a @click="openAgreement(agreement.user)">《用户协议》</a>、<a @click="openAgreement(agreement.privacy)">《隐私政策》</a>、<a @click="openAgreement(agreement.kidPrivacy)">《儿童隐私保护声明》</a>、<a @click="openAgreement(agreement.personalInfo)">《个人信息采集清单》</a>和<a @click="openAgreement(agreement.thirdInfo)">《第三方信息共享清单》</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript">
import env from '@tencent/vft-common/env';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import openApp from '@tencent/vft-common/openapp';
import atom from '@tencent/vft-atom';
import Clipboard from '@tencent/vft-common/clipboard';
import { request } from '@tencent/vft-common/request';
import util from '@tencent/vft-common/util';
import * as report from './report';

const defaultDescText = 'QQ和微信登录是两个独立帐号，VIP身份不互通，登录前请确认你的常用帐号。';
// 能登录微信
const wxloginWhiteList = ['app', 'wechat', 'weishi'];
const hasOwn = Object.prototype.hasOwnProperty;
let instance;
let cacheWhiteList;

export default {
  data() {
    return {
      appName: '腾讯视频',
      visible: false, // 是否显示登录弹窗
      desc: '', // 副标题展示
      jumpUrl: '', // 登录完成后的跳转地址
      pageUrl: location.href, // 页面地址
      isLogin: false, // 是否已登录
      isLoginExpired: false, // 登录态已过期
      loginType: '', // 当前登录类型
      canLoginQQ: !env.isMqq, // 能否登录QQ
      canLoginWechat: env.isApp || env.isTenvideoUnion, // 能否登录微信
      canOpenApp: false, // 能否拉起腾讯视频
      inWxMiniApp: false, // 是否在微信小程序内
      env: env.app, // 当前环境，wechat
      forceReload: true, // 页面回退时，是否强制刷新页面
      isPrivateMode: false, // 隐私模式
      insideIframe: false, // 兼容 iframe
      isAgreementChecked: false,
      agreement: {
        user: 'https://m.v.qq.com/about/privacy.html',
        privacy: 'https://privacy.qq.com/document/priview/3fab9c7fc1424ebda42c3ce488322c8a',
        kidPrivacy: 'https://privacy.qq.com/mb/policy/kids-privacypolicy',
        personalInfo: 'https://privacy.qq.com/document/preview/18f3ac8cb4364ed8b2ba596a9bfe3111',
        thirdInfo: 'https://privacy.qq.com/document/preview/ba4294dc9d4a45a89f3d682eb07a489b',
      },
    };
  },
  computed: {
    canLogin() {
      return this.canLoginWechat || this.canLoginQQ;
    },
    descText() {
      if (this.isPrivateMode) {
        return '当前环境cookie已被您设置禁用，无法正常使用登录服务，请您重新打开后重试。您也可以前往腾讯视频App使用本功能或参与本活动。';
      }
      if (env.isMqq) {
        return `如需切换微信帐号，${this.canOpenApp ? '点击打开腾讯视频，即可使用微信登录；' : '可点击复制链接，发送给任意微信好友，并点击链接，即可登录微信。'}如需切换其他QQ帐号，可在QQ【设置】中切换。${defaultDescText}`;
      }
      if (env.isWechat && !this.canLoginWechat) {
        return `如需切换微信帐号，请在微信【设置】—【切换帐号】中切换登录帐号。${defaultDescText}`;
      }
      if (this.canLoginWechat && this.canLoginQQ) {
        return defaultDescText;
      }
      if (this.canLoginWechat || this.canLoginQQ) {
        const loginTypeName = this.canLoginWechat ? '微信' : 'QQ';
        const disableLoginTypeName = this.canLoginWechat ? 'QQ' : '微信';
        return `当前环境只支持登录${loginTypeName}帐号，如需登录${disableLoginTypeName}帐号，可点击<span id="clipboard" style="color: #ff6022">复制链接</span>，发送给任意${disableLoginTypeName}好友，并点击链接，即可登录${disableLoginTypeName}。${defaultDescText}`;
      }
      return `当前环境不支持QQ帐号和微信帐号登录，${this.canOpenApp ? '请点击打开腾讯视频，' : '请复制链接到微信或者QQ发送给任意好友，再次点击链接'}即可使用帐号登录。${defaultDescText}`;
    },
  },
  created() {
    if (env.isWechat && (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke)) {
      document.addEventListener('WeixinJSBridgeReady', this.init.bind(this), false);
    } else {
      this.init();
    }
  },
  mounted() {
    instance = this;

    // fix 微信切换到登录界面时，手动返回页面由于页面 cache 导致页面无刷新问题
    window.addEventListener('pageshow', (event) => {
      if (event && event.persisted) {
        // 通过 foceReload=false 避免页面回退的时候，强制刷新
        // 业务可通过注册 reinit 方法，可在回退的时候触发页面异步刷新数据
        if (this.forceReload) {
          window.location.reload();
        } else if (typeof window.reinit === 'function') {
          window.reinit();
        }
      }
    });
  },
  methods: {
    init() {
      login.init(() => {
        this.isLogin = login.isLogin();
        this.loginType = login.loginType();
        this.setEnv();
      });
    },
    /**
     * 更新状态
     */
    updateState(callback) {
      const timer = setTimeout(() => {
        callback();
      }, 300);
      login.onInit(async () => {
        let isStrictLogin = login.isLogin();
        if (isStrictLogin && login.loginType() === 'qq' && cookie.get('uin') && !cookie.get('skey')) {
          isStrictLogin = false;
        }
        await this.setEnv();
        clearTimeout(timer);
        this.isLogin = login.isLogin();
        this.isLoginExpired = !!(!isStrictLogin && login.isLogin());
        this.loginType = login.loginType();
        // 能登录微信
        if ((this.env === 'wechat' && this.loginType === 'wx') && !this.isLoginExpired) {
          this.canLoginWechat = false;
        }
        if (typeof callback === 'function') {
          callback();
        }
      });
    },
    /**
     * 设置环境
     */
    async setEnv() {
      // eslint-disable-next-line no-underscore-dangle
      this.inWxMiniApp = window.__wxjs_environment && window.__wxjs_environment === 'miniprogram';
      this.canLoginQQ = !env.isMqq && !this.inWxMiniApp;
      this.isPrivateMode = !navigator.cookieEnabled;
      this.isAgreementChecked = false;

      if (env.isTenvideoUnion || (this.env === 'wechat' && this.loginType !== 'wx') || wxloginWhiteList.indexOf(this.env) > -1) {
        this.canLoginWechat = true;
      }

      // 能拉起腾讯视频
      const appLaunchWhiteList = ['wechat', 'mqq', 'app', 'qqbrowser'];
      if (appLaunchWhiteList.indexOf(this.env) > -1) {
        this.canOpenApp = true;
      }

      if ((!env.isApp || !env.isTenvideoUnion) && !env.isMqq && !env.isWechat) {
        // 不符合以上条件的，检查线上白名单
        const whiteList = await this.requestWhiteList();
        const ua = navigator.userAgent;
        for (let i = 0, len = whiteList.length; i < len; i++) {
          const app = whiteList[i];
          if (app.ua && app.ua.length > 0) {
            for (let j = 0, len = app.ua.length; j < len; j++) {
              const conf = app.ua[j];
              if (conf && ua.match(new RegExp(conf.rule, 'i'))) {
                this.canLoginWechat = app.enableWechatLogin;
                this.canLoginQQ = app.enableQQLogin;
                this.canOpenApp = app.enableOpenApp;
                break;
              }
            }
          }
        }
      }
      if (this.isPrivateMode) {
        this.canLoginQQ = false;
        this.canLoginWechat = false;
      }
    },
    async requestWhiteList() {
      return new Promise((resolve) => {
        if (cacheWhiteList) {
          return resolve(cacheWhiteList);
        }
        this.wujiRequest().then((res) => {
          if (res && Array.isArray(res.data) && res.data.length > 0) {
            cacheWhiteList = res.data;
            return resolve(res.data);
          }
          resolve([]);
        })
          .catch(() => {
            resolve([]);
          });
      });
    },
    wujiRequest() {
      // eslint-disable-next-line
      const dataPreload = window._dataPreload
      if (dataPreload && dataPreload.LoginPanel) {
        return Promise.resolve(dataPreload.LoginPanel);
      }
      // http://wuji.oa.com/p/edit?appid=vip&schemaid=login-white-list
      return request('https://v.qq.com/cache/wuji/object/?appid=vip&schemaid=login-white-list&schemakey=bfe09fad42e44099953f2739ebab8cb9&link=1', {
        link_query: 'include=rule',
      }, {
        withCredentials: false,
      });
    },
    popup(param = {}) {
      if (param) {
        const { jumpUrl = '', iframe, onLogin, desc = '', isLoginExpired } = param;
        this.jumpUrl = jumpUrl;
        this.insideIframe = iframe;
        this.onLogin = onLogin;
        this.desc = desc;
        if (isLoginExpired) {
          this.isLogin = false;
          this.isLoginExpired = true;
        }
      }
      this.visible = true;

      report.expose({
        f_module: this.isLogin ? '切换登录' : '登录',
        f_type: 0,
      });
      this.doReport('expose', 'qq');
      this.doReport('expose', 'wx');
    },
    hide() {
      this.visible = false;
    },
    actionLogin(type) {
      this.doReport('click', type);
      if ((type === 'qq' && env.isMqq) || (type === 'wx' && env.isWechat && !this.canLoginWechat)) return;
      if ((type === 'wx' && !this.canLoginWechat) || (type === 'qq' && !this.canLoginQQ)) {
        if (this.canOpenApp && !this.inWxMiniApp) {
          this.launchApp();
        } else if ((type === 'wx' && !env.isWechat) || (type === 'qq' && !env.isMqq)) {
          this.clipboard();
        }
      } else if (this.env !== 'mqq') {
        if (!this.isAgreementChecked) {
          return atom.toast(
            '请先勾选“同意《用户协议》、《隐私政策》、《儿童隐私保护声明》、《个人信息采集清单》和《第三方信息共享清单》”',
            { duration: 1000 }, // 产品设计1秒消失
          );
        }
        const param = {
          type,
        };
        if (this.jumpUrl) {
          param.url = this.jumpUrl;
        }
        this.switchLogin(param);
      }
    },
    switchLogin(param = {}) {
      if (env.isWeChatMiniProgram && util.getUrlParam('mpcookie')) {
        return login.openLogin();
      }

      if (typeof param.onLogin === 'function') {
        this.onLogin = param.onLogin;
      }
      if (param.jumpUrl) {
        this.jumpUrl = param.jumpUrl;
      }

      if (param.type === 'wx' && !this.canLoginWechat) {
        this.visible = true;
      } else {
        let isCallbacked = false;
        const onLogin = (response) => {
          if (!isCallbacked) { // 避免重复调用
            setTimeout(() => {
              isCallbacked = true;
              this.onSuccessLogin(param, response);
              atom.hideLoading();
            }, 500);
          }
        };
        if (env.isApp) { // 包括 phone 和 pad
          atom.once('onActionLoginFinish', onLogin);
        }
        if (env.isWeishi) {
          this.doLoginWeishi().then((isLogin) => {
            onLogin({ result: { isLogin }, errCode: 0 });
          });
        } else if (env.isQQSports || env.isQQMusic || env.isTenvideoUnion) {
          atom.openLogin(param.type).then(() => {
            onLogin({ result: { isLogin: true }, errCode: 0 });
          });
        } else if (env.isApp && atom.switchLogin) {
          atom.showLoading('正在登录', { timeout: 5000 });
          atom.switchLogin(param.type).then((res) => {
            if (!env.isAndroid) {
              onLogin(res);
            }
          });
          atom.once('onSwitchLoginStateResponse', (res) => {
            if (res && res.result && res.result.switchResult) {
              onLogin(res);
            }
          });
        } else if (this.insideIframe) {
          const ru = encodeURIComponent(window.parent.location.href);
          const jumpUrl = `http://film.qq.com/weixin/login.html?ru=${ru}&type=${param.type}`;
          window.parent.location.href = jumpUrl;
        } else {
          login.openLogin(param);
        }
        this.hide();
      }
    },
    delay(timeout = 500) {
      return new Promise((resolve) => {
        setTimeout(resolve, timeout);
      });
    },
    logout() {
      return new Promise((resolve) => {
        login.logout(resolve);
      });
    },
    loadScript(id, url) {
      return new Promise((resolve) => {
        util.loadScript(id, url, resolve);
      });
    },
    // 在微视APP内，使用APP登录组件
    async doLoginWeishi() {
      if (!env.isTenvideoUnion) {
        // 旧版本不支持登录态打通，需要先清掉视频票据，此步操作又未完成，可能会出现票据混乱问题
        await this.logout();
      }
      try {
        if (cookie.get('openid') || env.isIphone) {
          await atom.invoke('weishi.logout');
          if (env.isAndroid) {
            await this.delay(100);
          }
        }
      } catch (e) {
        console.error('weishi.logout', e);
      }
      // 清cookie原因是，微视端内需要先清登录态再拉登录，而安卓端会出现退出登录后仍存在票据信息
      // 需要清除票据保证退出登录成功
      const wsCookies = ['appid', 'openid', 'accessToken', 'refreshToken', 'iAuthType', 'sUid', 'sSessionKey', 'vqq_appid', 'vqq_access_token', 'vqq_vuserid', 'vqq_vusession', 'vqq_openid'];
      wsCookies.forEach((key) => {
        cookie.remove(key, {
          domain: 'qq.com',
          path: '/',
        });
      });
      try {
        await atom.openLogin();
        return true;
      } catch (e) {
        console.error('weishi.login', e);
      }
      return false;
    },
    async launchApp() {
      let schemeUrl = `tenvideo2://?action=10&openurl=${encodeURIComponent(this.pageUrl)}`;
      if (this.pageUrl.match(/^(tenvideo2|txvideo):\/\//)) {
        schemeUrl = this.pageUrl;
      }
      this.hide();
      if (!await openApp.launch(schemeUrl)) {
        // 拉起失败
        location.href = `https://film.qq.com/h5/app/openapp.html?openurl=${encodeURIComponent(this.pageUrl)}&auto=0`;
      }
    },
    clipboard() {
      // eslint-disable-next-line
      new Clipboard({
        text: this.pageUrl || location.href,
        success() {
          atom.toast('已复制链接');
        },
        error() {
          atom.toast('暂不支持复制功能，可手动分享此页面到微信打开或者直接复制该页面地址！');
        },
      });
      this.hide();
    },
    descTextClick(e) {
      if (e.target.id === 'clipboard') {
        this.clipboard();
      }
    },
    onSuccessLogin(param, res) {
      if ((env.isApp || env.isWeishi || env.isQQSports || env.isQQMusic || env.isTenvideoUnion) && typeof this.onLogin === 'function') {
        const result = res && res.result && res.errCode === 0 ? res.result : null;
        this.onLogin(result);
      } else if (param.url || param.jumpUrl) { // 修改化定义的跳转地址
        location.href = param.url || param.jumpUrl;
      } else if (typeof window.reinit === 'function') { // 调用全局注册的 reinit 方法
        window.reinit();
      } else { // 刷新当前页面
        location.reload();
      }
    },
    doReport(event = 'expose', type = 'qq') {
      const loginType = type === 'qq' ? 'QQ' : '微信';
      const actionType = this.isLogin ? '切换' : '登录';
      const params = {
        f_module: this.isLogin ? '切换登录' : '登录',
        f_resource: `${loginType}${actionType}按钮`,
        f_type: 4,
      };
      if (!env.isApp && ((type === 'qq' && !this.canLoginQQ) || (type === 'wx' && !this.canLoginWechat))) {
        if ((type === 'qq' && env.isMqq) || (type === 'wx' && env.isWechat)) {
          params.f_resource = `${loginType}无法${actionType}（${env.isMqq ? 'QQ' : '微信'}内）`;
        } else if (this.canOpenApp) {
          params.f_resource = `${loginType}无法${actionType}，拉腾讯视频按钮`;
        } else {
          params.f_resource = `${loginType}无法${actionType}，复制链接按钮`;
        }
      }

      report[event](params);
    },
    openAgreement(url) {
      // iframe 跳转全屏展示
      if (this.insideIframe) {
        window.parent.location.href = url;
        return;
      }
      atom.openUrl(url);
    },
  },
  install(Vue, option = {}) {
    Object.keys(option).forEach((key) => {
      if (hasOwn.call(instance, key) && option[key]) {
        instance[key] = option[key];
      }
    });
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$openLogin = function (param) {
      instance.updateState(() => {
        if (env.isWeishi || env.isQQSports || env.isQQMusic || env.isKidApp
        || env.isTenvideoUnion || (env.isWeChatMiniProgram && util.getUrlParam('mpcookie'))) {
          instance.switchLogin(param);
        } else {
          instance.popup(param);
        }
      });
    };
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$switchLogin = function (param) {
      instance.updateState(() => {
        instance.switchLogin(param);
      });
    };
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$checkLogin = function (param) {
      return new Promise((resolve) => {
        login.isStrictLogin((isLogin) => {
          if (isLogin) {
            resolve(true);
          } else {
            resolve(false);
            instance.updateState(() => {
              instance.isLoginExpired = login.isLogin() && !isLogin;
              instance.isLogin = login.isLogin();
              instance.popup(param);
            });
          }
        });
      });
    };
  },
};
</script>

<style lang='scss' src="./index.scss" scoped></style>
